import { forwardRef } from 'react';

import { PaymentMethodsPanel } from '../PaymentMethodsPanel';
import { QuickPaymentMethods, type QuickPaymentMethod } from '../QuickPaymentMethods';
import type { UsePosPaymentsResult } from '../../hooks/usePosPayments';

export interface PosPaymentsSectionProps {
  paymentShortcutLabel: string | null;
  showDetailedPayment: boolean;
  hasSplitPayment: boolean;
  quickPaymentMethods: QuickPaymentMethod[];
  selectedMethodId: number | null | undefined;
  payments: UsePosPaymentsResult;
  totalDue: number;
  currency: string;
  hasLines: boolean;
  isProcessingCheckout: boolean;
  isPaymentsLoading: boolean;
  onQuickPayment: (methodId: number) => void;
  onSplitPayment: () => void;
  onSimplePayment: () => void;
}

export const PosPaymentsSection = forwardRef<HTMLDivElement, PosPaymentsSectionProps>(function PosPaymentsSection({
  paymentShortcutLabel,
  showDetailedPayment,
  hasSplitPayment,
  quickPaymentMethods,
  selectedMethodId,
  payments,
  totalDue,
  currency,
  hasLines,
  isProcessingCheckout,
  isPaymentsLoading,
  onQuickPayment,
  onSplitPayment,
  onSimplePayment,
}, ref) {
  return (
    <section className="pos-panel pos-screen__payments-section" aria-label="Métodos de pago">
      <header className="pos-panel__header">
        <h2 className="pos-panel__title">Pagos</h2>
        {paymentShortcutLabel ? <span className="pos-panel__meta">Atajo {paymentShortcutLabel}</span> : null}
        {showDetailedPayment ? (
          <button type="button" className="pos-panel__toggle" onClick={onSimplePayment} disabled={hasSplitPayment}>
            Pago simple
          </button>
        ) : (
          <button
            type="button"
            className="pos-panel__toggle"
            onClick={onSplitPayment}
            disabled={!hasLines || isProcessingCheckout || isPaymentsLoading}
          >
            Dividir pago
          </button>
        )}
      </header>
      <div className="pos-screen__panel-body" ref={ref}>
        {!showDetailedPayment ? (
          <QuickPaymentMethods
            methods={quickPaymentMethods}
            selectedMethodId={selectedMethodId}
            onSelect={onQuickPayment}
            disabled={!hasLines || isProcessingCheckout}
            loading={isPaymentsLoading}
          />
        ) : null}
        {showDetailedPayment ? (
          <div className="pos-screen__payment-detail">
            <PaymentMethodsPanel
              payments={payments}
              totalDue={totalDue}
              currency={currency}
              showHeader={false}
              readOnly={!hasLines || isProcessingCheckout}
              compactRows
            />
          </div>
        ) : null}
      </div>
    </section>
  );
});

export default PosPaymentsSection;
